// Brittfurn projekt, listar sparade visualiseringar (tapet/matta) och Houlès-stång-konfigurationer.

(function () {
  const BACKEND = (document.querySelector('meta[name="bf-backend-url"]') || {}).content
    || 'https://backend-sam-8064s-projects.vercel.app';

  // Bearer-token från localStorage (delas med bf-account.js/bfUpAuth),   // tredjepartscookien blockeras av Safari/inkognito, så cookie är bara fallback.
  function authHeaders(extra) {
    const h = Object.assign({}, extra);
    try {
      const t = localStorage.getItem('bf_token');
      if (t) h.Authorization = 'Bearer ' + t;
    } catch {}
    return h;
  }

  // Vänta på att bf-account.js hunnit göra token-exchange (första sidladdningen).
  function tokenReady() {
    try { if (localStorage.getItem('bf_token')) return Promise.resolve(); } catch {}
    if (!window.bfCustomerBootstrap) return Promise.resolve();
    return new Promise((resolve) => {
      let done = false;
      const fin = () => { if (!done) { done = true; resolve(); } };
      document.addEventListener('bf:account-ready', fin, { once: true });
      setTimeout(fin, 3000);
    });
  }

  function api(path, options = {}) {
    return fetch(BACKEND + path, {
      credentials: 'include',
      ...options,
      headers: authHeaders({ 'Content-Type': 'application/json', ...(options.headers || {}) }),
    }).then(async (r) => {
      const t = await r.text();
      let body; try { body = JSON.parse(t); } catch { body = { raw: t }; }
      if (!r.ok) throw Object.assign(new Error(body.error || r.statusText), { status: r.status });
      return body;
    });
  }

  const TYPE_LABEL = {
    tapet: 'Tapetvisualisering',
    matta: 'Mattvisualisering',
    stang: 'Stångkonfiguration',
  };

  async function loadList(root) {
    root.innerHTML = '<p style="color:#888;font-style:italic">Laddar...</p>';
    try {
      await tokenReady();
      const { configurations } = await api('/api/configurations');
      if (configurations.length === 0) {
        root.innerHTML = '<p style="color:#888;font-style:italic">Du har inga sparade projekt ännu. Skapa en tapetvisualisering eller konfigurera en Houlès-stång, så dyker de upp här.</p>';
        return;
      }
      const grid = document.createElement('div');
      grid.className = 'bf-projects__grid';
      for (const c of configurations) {
        const card = document.createElement('div');
        card.className = 'bf-project-card';
        const cover = c.preview_url
          ? `<a href="#" data-bf-project-open="${c.id}" class="bf-project-card__cover" style="background-image:url(${c.preview_url})"></a>`
          : `<div class="bf-project-card__cover"></div>`;
        const dateStr = new Date(c.created_at).toLocaleDateString('sv-SE');
        card.innerHTML = `
          ${cover}
          <div class="bf-project-card__body">
            <span class="bf-project-card__type">${TYPE_LABEL[c.type] || c.type}</span>
            <h4 style="margin:0 0 4px;font-size:14px">${c.title || 'Sparat projekt'}</h4>
            <p style="margin:0;color:#888;font-size:12px">${dateStr}</p>
            <div style="margin-top:8px;display:flex;gap:8px">
              <button class="bf-board-detail__btn" data-bf-project-resume="${c.id}" data-bf-project-type="${c.type}">Öppna igen</button>
              <button class="bf-board-detail__item-remove" data-bf-project-delete="${c.id}">Ta bort</button>
            </div>
          </div>
        `;
        grid.appendChild(card);
      }
      root.innerHTML = '';
      root.appendChild(grid);
    } catch (e) {
      root.innerHTML = `<p style="color:#b22222">Fel: ${e.message}</p>`;
    }
  }

  document.addEventListener('click', async (e) => {
    const del = e.target.closest('[data-bf-project-delete]');
    if (del) {
      e.preventDefault();
      if (!confirm('Ta bort detta sparade projekt?')) return;
      const id = del.getAttribute('data-bf-project-delete');
      await api('/api/configurations/' + id, { method: 'DELETE' });
      const list = document.querySelector('[data-bf-projects-list]');
      if (list) loadList(list);
      return;
    }
    const resume = e.target.closest('[data-bf-project-resume]');
    if (resume) {
      e.preventDefault();
      const id = resume.getAttribute('data-bf-project-resume');
      const type = resume.getAttribute('data-bf-project-type');
      // Routing till respektive verktyg med config-id i query
      if (type === 'stang') location.href = `/collections/houles?config=${id}`;
      else if (type === 'tapet') location.href = `/pages/visualisering?config=${id}`;
      else if (type === 'matta') location.href = `/pages/mattvisualisering?config=${id}`;
    }
  });

  function init() {
    const list = document.querySelector('[data-bf-projects-list]');
    if (list) loadList(list);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
